import flow from './flow.json';
import Netverify from './netverify';
import perform from './perform.html';
angular.module('app.holding.dashboard.onboarding').config([
    '$stateProvider',
    ($stateProvider) => {
        $stateProvider
            .state('verification.netverify', {
            data: {
                flow,
                heroNoMobileActionTabs: true,
                hideFooter: true,
                noMobileCompoents: true,
                skipSetupCheck: true,
            },
            params: {
                code: {
                    type: 'int',
                },
            },
            url: '/:code/netverify',
            views: {
                '': {
                    component: Netverify,
                },
            },
        })
            .state('verification.netverify.perform', {
            data: {
                skipSetupCheck: true,
            },
            template: perform,
            url: '/perform',
        });
    },
]);



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/verification/controllers/netverify/routing.ts